export default {
  listingGradeLabel: {
    id: 'buyback_refurbisher_listing_grade_label',
    defaultMessage: 'Grade',
  },
  listingBackBoxPriceLabel: {
    id: 'buyback_refurbisher_listing_backbox_price_label',
    defaultMessage: 'BackBox Price',
  },
  listingPriceLabel: {
    id: 'buyback_refurbisher_listing_price_label',
    defaultMessage: 'Price',
  },
  listingStatusLabel: {
    id: 'buyback_refurbisher_listing_status_label',
    defaultMessage: 'Status',
  },
  turnOffline: {
    id: 'buyback_refurbisher_listing_offline_cta',
    defaultMessage: 'Turn offline',
  },
  turnOnline: {
    id: 'buyback_refurbisher_listing_online_cta',
    defaultMessage: 'Turn online',
  },
  priceInputLabel: {
    id: 'buyback_refurbisher_listing_price_input_label',
    defaultMessage: 'Price ({currency})',
  },
  backboxPriceWarningMessage: {
    id: 'buyback_refurbisher_listing_backbox_price_warning_message',
    defaultMessage: 'Enter a price above {backboxPrice} to get the BackBox',
  },
  backboxPriceOkMessage: {
    id: 'buyback_refurbisher_listing_backbox_price_ok_message',
    defaultMessage: 'You have got the BackBox',
  },
  offlineStatus: {
    id: 'buyback_refurbisher_listing_backbox_offline_message',
    defaultMessage: 'Offline',
  },
  save: {
    id: 'buyback_refurbisher_listing_save',
    defaultMessage: 'Save',
  },
  priceToWinBackboxTitle: {
    id: 'buyback_quotes_price_to_win_title',
    defaultMessage: 'Price to win BackBox',
  },
  priceToWinBackboxTooltip: {
    id: 'buyback_quotes_price_to_win_tooltip',
    defaultMessage: 'This price is influenced by your trade-in quality KPIs',
  },
}
